import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import rootReducer from "./../common/reducers";
import { StoreState } from "./../common/types/index";
import { AllActions } from "./../common/actions/index";
import { composeEnhancers } from "../../src/config";

export interface HistoricalFilters {
  selectedReport: string;
  selectedStates: string[];
  selectedStateChoices: [];
  selectedStartDate: string;
  selectedEndDate: string;
}

export const initialQueryState = {
  filters: {
    selectedReport: "CBS",
    selectedStates: ["0"],
    selectedStartDate: "1934",
    selectedEndDate: new Date().getFullYear() - 1,
  },
  sort: {
    sortField: "YEAR",
    sortOrder: "desc",
  },
  fixedDisplayFields: ["YEAR"],
  displayFields: ["STNAME", "TOTAL", "BRANCHES", "New_Char"],
  urls: {
    apiJson: null,
    csvDownload: null,
    browserPath: "",
  },
};

export const initialState = {
  query: initialQueryState,
  ui: {
    filtersCollapsed: false,
    filterPanelDetail: false,
    filterPanelDetailSection: "",
    dataLoaded: true,
    requestInProgress: false,
    fields: [""],
  },
  config: {
    docsPath: "/docs/summary_properties.yaml",
    apiPath: "/api/summary",
  },
  results: {},
  columns: null,
};

export const storeCreator = (initState: StoreState.All) => {
  return createStore<StoreState.All, AllActions, any, any>(
    rootReducer,
    initState,
    composeEnhancers(applyMiddleware(thunkMiddleware)),
  );
};
